///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-manual-count-select')) {
      const commentRequirement = new CommentRequirement();
      // display comment notice on page load if necessary
      commentRequirement.displayCommentNotice();

      document.querySelector('.js-manual-count-select').addEventListener('input', function() {
        commentRequirement.requireCommentAlert();
      });

      document.querySelector('.js-comment-field').addEventListener('keyup', function() {
        commentRequirement.clearCommentAlert();
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function CommentRequirement() {
    this.commentField   = document.querySelector('.js-comment-field');
    this.commentNotice  = document.querySelector('.js-comment-alert');
    this.selectedAnswer = document.querySelector('.js-manual-count-select');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Toggles comment notice based on associated
  //               comment field value when 'Manual Staff count'
  //               has a selected value.
  //
  //
  CommentRequirement.prototype.clearCommentAlert = function() {
    if (this.selectedAnswer.value != '') {
      if (this.commentField.value != '') {
        hideCommentNotice(this.commentField, this.commentNotice);
      } else if (this.commentField.value == '') {
        showCommentNotice(this.commentField, this.commentNotice);
      }
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Displays comment notice on page load
  //               when 'Manual Staff count' has a value.
  //
  CommentRequirement.prototype.displayCommentNotice = function() {
    if ((this.selectedAnswer.value != '') && (this.commentField.value == '')) {
      showCommentNotice(this.commentField, this.commentNotice);
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Show comment required alert
  //               and outline comment box
  //
  CommentRequirement.prototype.requireCommentAlert = function() {
    if ((this.selectedAnswer.value != '') && (this.commentField.value == '')) {
      showCommentNotice(this.commentField, this.commentNotice);
    } else {
      hideCommentNotice(this.commentField, this.commentNotice);
    }
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Hide comment alert elements/stylings
  //
  function hideCommentNotice(commentField, commentNotice) {
    commentField.classList.remove('border', 'border-warning');
    commentNotice.classList.add('d-none');
  }

  ///////////////////////////////////////////////
  //
  // Description - Show comment alert elements/stylings
  //
  function showCommentNotice(commentField, commentNotice) {
    commentField.classList.add('border', 'border-warning');
    commentNotice.classList.remove('d-none');
  }
}());
